import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    orders: [],
    orderTotal: 0,
    returns: [],
    returnTotal: 0,
    afterCares: [],
    loading: true,
    returnFlow: false,
    currentOrderDetail: undefined,
    orderToken: undefined,
    confirmedReturn: undefined,
    errorMessage: '',
    returnRequest: undefined,
};
export default createSlice({
    name: 'orders',
    initialState: initialState,
    reducers: {
        updateOrders: (state, action) => {
            state.orders = action.payload;
        },
        updateOrdersNext: (state, action) => {
            state.orders = action.payload.orders;
            state.orderTotal = action.payload.orderTotal;
        },
        updateOrderDetail: (state, action) => {
            const { id, orderDetail } = action.payload;
            for (let index = 0; index < state.orders.length; index++) {
                const element = state.orders[index];
                if (element.orderNumber === id) {
                    state.orders[index] = orderDetail;
                }
            }
        },
        saveCurrentOrderDetail: (state, action) => {
            state.currentOrderDetail = action.payload.orderDetail;
        },
        clearErrors: (state) => {
            state.errorMessage = '';
        },
        updateReturns: (state, action) => {
            state.returns = action.payload;
        },
        updateReturnsNext: (state, action) => {
            state.returns = action.payload.returns;
            state.returnTotal = action.payload.returnTotal;
        },
        updateOrderRequest: (state, action) => {
            state.returnRequest = action.payload;
        },
        updateOrderToken: (state, action) => {
            state.orderToken = action.payload;
        },
        startReturnFlow: (state, action) => {
            state.returnFlow = action.payload;
        },
        confirmReturn: (state, action) => {
            state.confirmedReturn = action.payload;
        },
        updateAfterCares: (state, action) => {
            state.afterCares = action.payload;
        },
        updateLoading: (state, action) => {
            state.loading = action.payload;
        },
        setErrorMessage: (state, action) => {
            console.log('Setting error message to ' + action.payload);
            state.errorMessage = action.payload;
        },
    },
});
